import axios from 'axios';
import { isAfter } from 'date-fns';
import { topicEnum } from './topicEnum.js';

class MqttComponent {
  constructor(authInterceptor) {
    this.client = void 0;
    this.url = "";
    this.clientId = "";
    this.messageDate = "";
    axios.interceptors.response.use(void 0, authInterceptor);
  }
  async authMqtt(token, host, AppTheme, clientId, environment) {
    try {
      const response = await axios.post(`${host}/mqttauth/v1/auth`, void 0, {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
          "x-client-id": clientId,
          "x-client-version": "1.0",
          "x-environment": environment,
          "x-app": AppTheme
        }
      });
      this.clientId = response?.data?.subscriberId;
      this.url = response?.data?.urlInfo?.completeUrl;
      return { clientId: this.clientId, url: this.url };
    } catch (error) {
      return error;
    }
  }
  async connectMqtt(clientAuth, urlAuth, vrioCustomerId, tokenDate, refreshIdToken, MQTT_REALTIME_ENTITLEMENT_FLAG, MQTT_FLAG) {
    let mqtt;
    if (MQTT_FLAG) {
      const mqttModule = await import('mqtt');
      mqtt = mqttModule.default;
    }
    this.client = mqtt.connect(urlAuth, {
      clientId: clientAuth,
      clean: false,
      properties: { sessionExpiryInterval: 3600 }
    });
    this.client.on("connect", () => {
      this.client.subscribe(`dgo/v1/${vrioCustomerId}/#`, { qos: 1 });
    });
    this.client.on("message", (topic, message) => {
      if (MQTT_REALTIME_ENTITLEMENT_FLAG && topic.includes(topicEnum.realTimeEntitlement)) {
        const messageData = JSON.parse(message?.toString());
        this.messageDate = new Date(messageData?.lastUpdateDateTime);
        const tokenDateUTC = new Date(tokenDate);
        const messageDateUTC = new Date(new Date(this.messageDate).toUTCString());
        if (isAfter(messageDateUTC, tokenDateUTC)) {
          refreshIdToken();
        }
      }
    });
    this.client.on("error", (err) => {
      console.error("Error:", err);
      this.client.end();
    });
    return this.client;
  }
}

export { MqttComponent as default };
//# sourceMappingURL=Mqtt.js.map
